export const isLoading = state => state.resetData.loading;

export const getStatus = state => {
  const status = {
    message: 'No Status',
    error: false,
    success: false,
    active: false,
  };

  if (state.resetData.data.children) {
    if (
      state.resetData.data.children.some(child => child.state === 'CREATED')
    ) {
      status.message = 'In Progress';
      status.active = true;
    }

    if (
      state.resetData.data.children.every(
        child => child.state === 'COMPLETED' || child.state === 'TERMINATED',
      )
    ) {
      status.message = 'Completed';
      status.active = false;
    }

    if (state.resetData.data.children.every(child => child.state === '')) {
      status.message = 'No Status';
      status.active = false;
    }
  }

  return status;
};
